import { filter } from "lodash";

export enum RouteTypeEnum {
  early = "early",
  late = "late",
  reschedule = "reschedule",
  none = "none",
}

export const routeTypeEnumValues = Object.values(RouteTypeEnum);
export const routeTypeEnumLabelMap: Record<RouteTypeEnum, string> = {
  [RouteTypeEnum.early]: "Morning Route",
  [RouteTypeEnum.late]: "Afternoon Route",
  [RouteTypeEnum.reschedule]: "Reschedule",
  [RouteTypeEnum.none]: "No Route",
};

export const routeTypeSelectOptions = routeTypeEnumValues.map((c) => ({
  label: routeTypeEnumLabelMap[c],
  value: c,
}));

export const routeTypeSelectOptionsNoReschedule = filter(
  routeTypeSelectOptions,
  (o) => o.value !== RouteTypeEnum.reschedule,
);
